// app/javascript/controllers/wistia_video_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    code: String,
    session: String,
    node: String,
    lesson: String
  }

  connect() {
    window._wq = window._wq || [];
    this.initWistia();
  }

  initWistia() {
    window._wq.push({
      id: this.codeValue,
      options: {
        plugin: {
          "captions-v1": { onByDefault: false, language: 'eng' }
        }
      },
      onReady: (video) => {
        this.bindTrackingEvents(video);
        this.dispatchLegacyEvent(video);
      }
    });
  }

  bindTrackingEvents(video) {
    video.bind('percentwatchedchanged', () => {
      const percentageWatched = Math.round((video.time() / video.duration()) * 100);
      const secondsWatched = Math.floor(video.time());

      this.saveActivity(percentageWatched, secondsWatched);
    });
  }

  async saveActivity(percentageWatched, secondsWatched) {
    const payload = {
      activity: {
        node: this.nodeValue,
        lesson: this.lessonValue,
        session: this.sessionValue,
        percentage_watched: percentageWatched,
        seconds_watched: secondsWatched
      }
    };

    try {
      await fetch('/activities', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector("[name='csrf-token']").content
        },
        body: JSON.stringify(payload)
      });
    } catch (error) {
      console.error("Failed to save activity:", error);
    }
  }

  dispatchLegacyEvent(video) {
    const event = new Event('OnVideoLoaded');
    document.addEventListener('OnVideoLoaded', (e) => {
      e.player = video;
    }, { once: true, capture: true });

    document.dispatchEvent(event);
  }
}
